import { TypedPath } from '../../../types/routes';

const merchantBasePath = '/merchant';

export const MerchantNavigation = {
  basePath: merchantBasePath,

  merchantChannelSettingsOverall: {
    pathPattern: () => {
      return `${merchantBasePath}/merchant-channel/:merchantChannelId/settings-overall`;
    },
    pathFromParams: params => {
      return `${merchantBasePath}/merchant-channel/${params.merchantChannelId}/settings-overall`;
    },
    paramsFromPath: (match: any) => {
      return { merchantChannelId: match.params.merchantChannelId };
    }
  } as TypedPath<{ merchantChannelId: string }>,
  merchantChannelSettingsDelivery: {
    pathPattern: () => {
      return `${merchantBasePath}/merchant-channel/:merchantChannelId/settings-delivery`;
    },
    pathFromParams: params => {
      return `${merchantBasePath}/merchant-channel/${params.merchantChannelId}/settings-delivery`;
    },
    paramsFromPath: (match: any) => {
      return { merchantChannelId: match.params.merchantChannelId };
    }
  } as TypedPath<{ merchantChannelId: string }>,
  merchantChannelSettingsLookAndFeel: {
    pathPattern: () => {
      return `${merchantBasePath}/merchant-channel/:merchantChannelId/settings-look-and-feel`;
    },
    pathFromParams: params => {
      return `${merchantBasePath}/merchant-channel/${params.merchantChannelId}/settings-look-and-feel`;
    },
    paramsFromPath: (match: any) => {
      return { merchantChannelId: match.params.merchantChannelId };
    }
  } as TypedPath<{ merchantChannelId: string }>,

  platformMerchantOrderList: {
    pathPattern: () => {
      return `${merchantBasePath}/merchant-channel/:merchantChannelId/platform-merchant-orders`;
    },
    pathFromParams: params => {
      return `${merchantBasePath}/merchant-channel/${params.merchantChannelId}/platform-merchant-orders`;
    },
    paramsFromPath: (match: any) => {
      return { merchantChannelId: match.params.merchantChannelId };
    }
  } as TypedPath<{ merchantChannelId: string }>,

  platformMerchantOrderDetails: {
    pathPattern: () => {
      return `${merchantBasePath}/merchant-channel/:merchantChannelId/platform-merchant-orders/:orderId`;
    },
    pathFromParams: params => {
      return `${merchantBasePath}/merchant-channel/${params.merchantChannelId}/platform-merchant-orders/${params.orderId}`;
    },
    paramsFromPath: (match: any) => {
      return { merchantChannelId: match.params.merchantChannelId, orderId: match.params.orderId };
    }
  } as TypedPath<{ merchantChannelId: string; orderId: string }>,

  platformSaleCatalogDetails: {
    pathPattern: () => {
      return `${merchantBasePath}/platform-sale-catalogs/`;
    },
    pathFromParams: _params => {
      return `${merchantBasePath}/platform-sale-catalogs/`;
    },
    paramsFromPath: (_match: any) => {
      return {};
    }
  } as TypedPath<{}>,

  merchantChannelCatalogDetails: {
    pathPattern: () => {
      return `${merchantBasePath}/merchant-channel-catalog/:merchantChannelCatalogId`;
    },
    pathFromParams: params => {
      return `${merchantBasePath}/merchant-channel-catalog/${params.merchantChannelCatalogId}`;
    },
    paramsFromPath: (match: any) => {
      return {
        merchantChannelCatalogId: match.params.merchantChannelCatalogId
      };
    }
  } as TypedPath<{ merchantChannelCatalogId: string }>,

  merchantChannelCatalogPreview: {
    pathPattern: () => {
      return `${merchantBasePath}/merchant-channel-catalog/:merchantChannelCatalogId/preview`;
    },
    pathFromParams: params => {
      return `${merchantBasePath}/merchant-channel-catalog/${params.merchantChannelCatalogId}/preview`;
    },
    paramsFromPath: (match: any) => {
      return {
        merchantChannelCatalogId: match.params.merchantChannelCatalogId
      };
    }
  } as TypedPath<{ merchantChannelCatalogId: string }>,

  merchantChannelCatalogCollectionSettings: {
    pathPattern: () => {
      return `${merchantBasePath}/merchant-channel-catalog/:merchantChannelCatalogId/collections/:collectionId/settings`;
    },
    pathFromParams: params => {
      return `${merchantBasePath}/merchant-channel-catalog/${params.merchantChannelCatalogId}/collections/${params.collectionId}/settings`;
    },
    paramsFromPath: (match: any) => {
      return {
        merchantChannelCatalogId: match.params.merchantChannelCatalogId,
        collectionId: match.params.collectionId
      };
    }
  } as TypedPath<{ merchantChannelCatalogId: string; collectionId: string }>,

  merchantChannelCatalogCollectionProductList: {
    pathPattern: () => {
      return `${merchantBasePath}/merchant-channel-catalog/:merchantChannelCatalogId/collections/:collectionId/products`;
    },
    pathFromParams: params => {
      return `${merchantBasePath}/merchant-channel-catalog/${params.merchantChannelCatalogId}/collections/${params.collectionId}/products`;
    },
    paramsFromPath: (match: any) => {
      return {
        merchantChannelCatalogId: match.params.merchantChannelCatalogId,
        collectionId: match.params.collectionId
      };
    }
  } as TypedPath<{ merchantChannelCatalogId: string; collectionId: string }>,

  merchantChannelCatalogCollectionProductDetails: {
    pathPattern: () => {
      return `${merchantBasePath}/merchant-channel-catalog/:merchantChannelCatalogId/collections/:collectionId/products/:productId`;
    },
    pathFromParams: params => {
      return `${merchantBasePath}/merchant-channel-catalog/${params.merchantChannelCatalogId}/collections/${params.collectionId}/products/${params.productId}`;
    },
    paramsFromPath: (match: any) => {
      return {
        merchantChannelCatalogId: match.params.merchantChannelCatalogId,
        collectionId: match.params.collectionId,
        productId: match.params.productUd
      };
    }
  } as TypedPath<{ merchantChannelCatalogId: string; collectionId: string; productId: string }>,
  support: {
    pathPattern: () => {
      return `${merchantBasePath}/support`;
    },
    pathFromParams: _params => {
      return `${merchantBasePath}/support`;
    },
    paramsFromPath: (_match: any) => {
      return {};
    }
  } as TypedPath<{}>
};
